module.exports = __webpack_public_path__ + "static/media/datu6.eaea2c1b.png";